import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import about from "../../../static/images/carsubs/aboutcs/bg_about.png";

// import reason1 from "../../../static/images/introRegisterOwner/reason1.svg";
// import reason2 from "../../../static/images/introRegisterOwner/reason2.svg";
// import reason3 from "../../../static/images/introRegisterOwner/reason3.svg";
// import reason4 from "../../../static/images/introRegisterOwner/reason4.svg";
// import reason5 from "../../../static/images/introRegisterOwner/reason5.svg";
// import reason6 from "../../../static/images/introRegisterOwner/reason6.svg";

// const LIST_ITEM = [
// 	{
// 		id: 1,
// 		icon: reason1,
// 		title: "Thu nhập",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// 	{
// 		id: 2,
// 		icon: reason2,
// 		title: "Nhanh chóng",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// 	{
// 		id: 3,
// 		icon: reason3,
// 		title: "Chủ động",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// 	{
// 		id: 4,
// 		icon: reason4,
// 		title: "Bảo hiểm",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// 	{
// 		id: 5,
// 		icon: reason5,
// 		title: "GPS",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// 	{
// 		id: 6,
// 		icon: reason6,
// 		title: "Chăm sóc đối tác",
// 		desc: `Lorem ipsum dolor sit amet consect vivamus Lorem ipsum dolor sit amet consect vivamus `,
// 	},
// ];

// const ListItem = () => {
// 	return (
// 		<div>
// 			<div className="list-reason isOffTablet">
// 				{LIST_ITEM.map((reason) => (
// 					<div className="reason-item" key={reason.id}>
// 						<div className="green-card-option">
// 							<div className="horizontal-content">
// 								<div className="horizontal-content--content">
// 									<h6>{reason.title}</h6>
// 									<p dangerouslySetInnerHTML={{ __html: reason.desc }} />
// 								</div>
// 								<div className="horizontal-content--img">
// 									<img loading="lazy" src={reason.icon} />
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				))}
// 			</div>
// 			<Swiper
// 				className="isShowTablet swiper-intro-register"
// 				slidesPerView={1.5}
// 				spaceBetween={15}
// 				modules={[Pagination]}
// 				pagination={{
// 					el: ".swiper-pagination",
// 					clickable: true,
// 					dynamicBullets: true,
// 				}}>
// 				{LIST_ITEM.map((reason) => (
// 					<SwiperSlide key={reason.id}>
// 						<div className="green-card-option reason-item">
// 							<div className="horizontal-content">
// 								<div className="horizontal-content--content">
// 									<h6>{reason.title}</h6>
// 									<p dangerouslySetInnerHTML={{ __html: reason.desc }} />
// 								</div>
// 								<div className="horizontal-content--img">
// 									<img loading="lazy" src={reason.icon} />
// 								</div>
// 							</div>
// 						</div>
// 					</SwiperSlide>
// 				))}
// 				<div className="swiper-pagination" />
// 			</Swiper>
// 		</div>
// 	);
// };

const AboutCS = () => {
	return (
		<div className="about-us">
			<div className="aboutus-intro space sec">
			<div className="m-container">
				<div className="intro-container">
					<div className="intro-container__info">
						<h2>MiCar - đối tác thuê xe dài hạn của MIOTO</h2>
				
						<p>Từ nhu cầu sử dụng xe để phục vụ việc đi lại, công tác… cũng như những ưu điểm vượt trội về sự tiện lợi, tính kinh tế so với việc mua xe, MiCar nay chính thức ra mắt dịch vụ thuê xe dài hạn. Là đối tác tin cậy đến từ MIOTO, MiCar thừa hưởng bề dày kinh nghiệm trong lĩnh vực cho thuê xe cũng như nguồn xe chất lượng và uy tín. MiCar không ngừng tối ưu hoá dịch vụ đồng thời đưa ra các chính sách và ưu đãi hết sức hấp dẫn nhằm mang đến cho cho quý khách hàng trải nghiệm thuê xe tuyệt vời như xe nhà.</p>
					</div>
					<div className="intro-container__img">
						<img loading="eager" src={about} />
					</div>
				</div>
			</div>
		</div>
	</div>
	);
};

export default AboutCS;
